export const clamp = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max)
}

export const widthAndHeightToAspectRatio = (width: number, height: number) => {
  const gcd = (a: number, b: number): number => {
    if (b === 0) return a
    return gcd(b, a % b)
  }
  const divisor = gcd(width, height)

  return `${width / divisor}/${height / divisor}`
}

export function abbreviate(
  number: number,
  maxPlaces: number | false,
  forcePlaces: number | false
) {
  number = Number(number)

  let abbr
  if (number >= 1e12) {
    abbr = 'T'
  } else if (number >= 1e9) {
    abbr = 'B'
  } else if (number >= 1e6) {
    abbr = 'M'
  } else if (number >= 1e3) {
    abbr = 'K'
  } else {
    abbr = ''
  }
  return annotate(number, maxPlaces, forcePlaces, abbr)
}

function annotate(
  number: number,
  maxPlaces: number | false,
  forcePlaces: number | false,
  abbr: string
) {
  // set places to false to not round
  let rounded: number | string = 0
  switch (abbr) {
    case 'T':
      rounded = number / 1e12
      break
    case 'B':
      rounded = number / 1e9
      break
    case 'M':
      rounded = number / 1e6
      break
    case 'K':
      rounded = number / 1e3
      break
    case '':
      rounded = number
      break
  }
  if (maxPlaces !== false) {
    const test = new RegExp('\\.\\d{' + (maxPlaces + 1) + ',}$')
    if (test.test('' + rounded)) {
      rounded = rounded.toFixed(maxPlaces)
    }
  }
  if (forcePlaces !== false) {
    rounded = Number(rounded).toFixed(forcePlaces)
  }
  return rounded + abbr
}

/**
 * Returns a random number between min (inclusive) and max (exclusive)
 */
export function getRandomArbitrary(min: number, max: number) {
  return Math.random() * (max - min) + min
}

/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer) and no greater than max (or the next integer
 * lower than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 */
export function getRandomInt(min: number, max: number) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}
